<template>
  <div class="progress_row">
    <span class="label">{{ fractions.length === 0 ? description : title }}</span>
    <div class="progressbar" v-if="fractions.length !== 0">
      <span
        class="progress green"
        v-if="greenLine > 0"
        :style="getLineStyle(greenLine)"
      >
        <span class="value">{{ greenLine }} %</span>
      </span>
      <span
        class="progress orange"
        v-if="orangeLine > 0"
        :style="getLineStyle(orangeLine)"
      >
        <span class="value">{{ orangeLine }} %</span>
      </span>
      <span
        class="progress red"
        v-if="redLine > 0"
        :style="getLineStyle(redLine)"
      >
        <span class="value">{{ redLine }} %</span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'progress-bar',
  props: {
    title: {
      type: String,
      required: true
    },
    fractions: {
      type: Array,
      required: true
    }
  },
  computed: {
    greenLine() {
      return this.getPercentage('BROADCAST_STATE_VERIFIED')
    },
    orangeLine() {
      return this.getPercentage('BROADCAST_STATE_UNVERIFIED')
    },
    redLine() {
      return this.getPercentage('BROADCAST_STATE_UNASSIGNED')
    },
    description() {
      if (this.title == 'EPG PLUS') {
        return this.$gettext('Pro EPG PLUS nejsou žádná data')
      } else if (this.title == 'EPG REST') {
        return this.$gettext('Pro EPG REST nejsou žádná data')
      } else {
        return this.$gettext('Nejsou dostupná žádná data')
      }
    }
  },
  methods: {
    getPercentage(name) {
      const partVerified = this.fractions.find(v => v.state === name)
      return partVerified ? partVerified.percentage : 0
    },
    getLineStyle(percentage) {
      return {
        'width': `${percentage}%`
      }
    }
  }
}
</script>
